import { useTranslation } from 'react-i18next'
import pencil from 'assets/icons/pencil.svg'
import { useEffect, useState } from 'react'
import styles from '../AllStyle.module.scss'

import deleteIcon from 'assets/icons/trash_del.svg'
import { useDispatch, useSelector } from 'react-redux'
import {
    deleteTrainings,
    getPersonalEmployee,
    postQualifications
} from 'service/PersonalCardService'
import { setPersonalInfo } from 'store/slices/PersonalCard'
import Notification from 'utils/Notifications'
import userInfo from 'utils/userInfo'

const TrainQualificationInfo = () => {
  const { t } = useTranslation('common')

  const [change, setChange] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const [title, setTitle] = useState(null)
  const [kind, setKind] = useState(null)
  const [position, setPosition] = useState(null)
  const [started, setStarted] = useState(null)
  const [ended, setEnded] = useState(null)
  const [certification_type, setCertification_type] = useState(null)
  const [certification, setCertification] = useState(null)

  let data
  const dispatch = useDispatch()
  const user = userInfo()
  const [render, setRender] = useState(false)

  const getData = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ru')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getData()
    setRender(false)
  }, [render])
  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const data = {
        title,
        kind,
        started,
        ended,
        certification_type,
        certification,
      }
      let response = await postQualifications(data, 'ru')

      setNotify({
        isOpen: true,
        message: 'Квалификация добавлена',
        type: 'success',
        sound: 'success',
      })

      setRender(true)
      setChange(false)
    } catch (error) {
      setNotify({
        isOpen: true,
        message: 'Ошибка',
        type: 'error',
        sound: 'error',
      })
    }
  }
  const info = useSelector((state) => state.personalcard.personal_info)

  const deleteUserInfo = async (id) => {
    try {
      let response = await deleteTrainings(id)
      setNotify({
        isOpen: true,
        message: 'Успешно удалено',
        type: 'success',
        sound: 'success',
      })

      setRender(true)
    } catch (error) {
      setNotify({
        isOpen: true,
        message: 'Ошибка',
        type: 'error',
        sound: 'error',
      })
    }
  }

  return (
    <div className={styles.wrapper}>
      <div style={{ width: '100%', height: '100%' }}>
        {change ? (
          <div className={styles.Design_true}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                
                <h4 className={styles.header_left_info}>
                  {t('auto.trainqualificationinfo_trainqualificationinfo.k1')}
                </h4>
              </div>
              <div className={styles.headerRight}></div>
            </div>

            <div className={styles.Design_change_block}>
              <ul className={styles.Design_desc}>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('diploma.topic')}</h3>
                  <input
                    type="text"
                    onChange={(e) => setTitle(e.target.value)}
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('archive.info_period_start')}</h3>
                  <input
                    type="date"
                    onChange={(e) => setStarted(e.target.value)}
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('calendar.end')}</h3>
                  <input
                    onChange={(e) => setEnded(e.target.value)}
                    type="date"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('europass.training_kind')}</h3>
                  <input
                    type="text"
                    onChange={(e) => setKind(e.target.value)}
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('europass.doc_type')}</h3>
                  <input
                    onChange={(e) => setCertification_type(e.target.value)}
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('plagiarism.col_document')}</h3>
                  <input
                    onChange={(e) => setCertification(e.target.files[0])}
                    type="file"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <div className={styles.change_btn}>
                  
                </div>
              </ul>

              <div className={styles.change_btn}>
                <button
                  onClick={() => setChange(false)}
                  className={styles.change_btn_Cancel}
                >
                  <p>{t('common.cancel')}</p>
                </button>
                <button
                  onClick={handleSubmit}
                  className={styles.change_btn_save}
                >
                  <p style={{ color: 'white' }}>{t('auto.surveyform_surveychangeform.k1')}</p>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.Design}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                
                <h4 className={styles.header_left_info}>
                  {t('auto.trainqualificationinfo_trainqualificationinfo.k1')}
                </h4>
              </div>
              <div className={styles.headerRight}>
                <img
                  src={pencil}
                  onClick={() => setChange(true)}
                  className={styles.headerRight_info}
                ></img>
              </div>
            </div>
            {info?.trainings
              ?.filter((elem) => elem.title !== null)
              .map((item) => (
                <ul className={styles.Design_desc}>
                  <li className={styles.Design_list}>
                    <p className={styles.Design_title}>{t('diploma.topic')}</p>
                    <p className={styles.Design_info}>{item?.title}</p>
                  </li>

                  <li className={styles.Design_list}>
                    <p className={styles.Design_title}>{t('archive.info_period_start')}</p>
                    <p className={styles.Design_info}>{item?.started}</p>
                  </li>

                  <li className={styles.Design_list}>
                    <p className={styles.Design_title}>{t('calendar.end')}</p>
                    <p className={styles.Design_info}>{item?.ended}</p>
                  </li>

                  <li className={styles.Design_list}>
                    <p className={styles.Design_title}>{t('europass.training_kind')}</p>
                    <p className={styles.Design_info}>{item?.kind}</p>
                  </li>
                  <li className={styles.Design_list}>
                    <p className={styles.Design_title}>{t('europass.doc_type')}</p>
                    <p className={styles.Design_info}>
                      {item?.certification_type}
                    </p>
                  </li>

                  <li className={styles.Design_list}>
                    <p className={styles.Design_title}>{t('plagiarism.col_document')}</p>
                    <button className={styles.change_btn_download}>
                      <a
                        target="_blank"
                        href={item?.certification}
                        style={{ color: 'white' }} rel="noreferrer"
                      >
                        {t('auto.awardsinfo_awardsinfo.k2')}
                      </a>
                    </button>

                    <button
                      onClick={() => deleteUserInfo(item.id)}
                      className={styles.change_btn_delete}
                    >
                      <img src={deleteIcon} style={{ color: 'white' }} alt="" />
                    </button>
                  </li>
                </ul>
              ))}
          </div>
        )}
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default TrainQualificationInfo
